@if (loading) {
  <mat-progress-bar mode="buffer" class="dialog-progress"></mat-progress-bar>
}

<div class="standard-dialog">
  <div class="header" mat-dialog-title>
    <div class="title-section">
      <h2>{{ (data.mode === 'create' ? 'Courses.Overview.AddSection' : 'Global.EditSection') | translate }}</h2>
      <p class="subtitle">{{ (data.mode === 'create' ? 'Courses.Overview.AddSectionDesc' : 'Global.UpdateDetails') | translate }}</p>
    </div>
    <button mat-icon-button (click)="dialogRef.close()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="form-content" [class.ai-generating]="isGenerating">
    <div class="w-100 mb-3">
      <mat-label class="form-label">{{ 'Global.Name' | translate }}</mat-label>
      <mat-form-field appearance="fill" class="soft-input w-100" subscriptSizing="dynamic">
        <input matInput [disabled]="loading || isGenerating || showTOC" [(ngModel)]="sectionName" (keyup.enter)="onSubmit()" [placeholder]="'Courses.EnterSectionTitle' | translate" />
      </mat-form-field>
    </div>

    @if (data.mode === 'create' && !showTOC) {
      <div class="instructions-section mb-3">
        <mat-label class="form-label">{{ 'Content.AdditionalInstructions' | translate }}</mat-label>
        <mat-form-field appearance="fill" class="soft-input w-100" subscriptSizing="dynamic">
          <textarea matInput [(ngModel)]="instructions" rows="3" [placeholder]="'Content.AdditionalInstructionsPlaceholder' | translate"></textarea>
        </mat-form-field>
      </div>
    }

    @if (showTOC) {
      <div class="toc-preview mt-4">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h3 class="mb-0 fw-bold">{{ 'Global.Content' | translate }}</h3>
          <button mat-button color="primary" (click)="regenerateSectionTOC()" [disabled]="isGenerating">
            <mat-icon>refresh</mat-icon>
            {{ 'Content.RegenerateWithInstructions' | translate }}
          </button>
        </div>

        <div class="lecture-list" cdkDropList (cdkDropListDropped)="dropLecture($event)">
          @for (lecture of plan.lectures; track lecture; let i = $index) {
            <div class="lecture-item" cdkDrag>
              <div class="drag-handle" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
              </div>
              <div class="lecture-content w-100">
                <mat-form-field appearance="fill" class="soft-input clean-input w-100 mb-2" subscriptSizing="dynamic">
                  <input matInput [(ngModel)]="lecture.title" [placeholder]="'Courses.EnterLectureTitle' | translate" />
                </mat-form-field>
                <mat-form-field appearance="fill" class="soft-input clean-input context-input w-100" subscriptSizing="dynamic">
                  <textarea matInput [(ngModel)]="lecture.subject" rows="3" [placeholder]="'Content.AdditionalInstructionsPlaceholder' | translate"></textarea>
                </mat-form-field>
              </div>
              <button mat-icon-button color="warn" (click)="deleteLecture(i)" class="delete-btn" matTooltip="Delete Lecture">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </div>
        <button mat-stroked-button class="w-100 mt-3 border-dashed" (click)="addLecture()">
          <mat-icon>add</mat-icon>
          {{ 'Courses.Overview.AddLecture' | translate }}
        </button>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="footer">
    <div class="left-actions">
      @if (data.mode === 'create' && !showTOC) {
        <button matButton="tonal" class="magic-btn" (click)="generateSectionTOC()" [disabled]="isGenerating || (!sectionName && !instructions)">
          @if (isGenerating) {
            <mat-spinner diameter="18" class="me-2 d-inline-block align-middle"></mat-spinner>
          }
          {{ 'ContentGenerator.GenerateWithAI' | translate }}
        </button>
      }
    </div>
    <div class="right-actions">
      <button mat-button (click)="dialogRef.close()">{{ 'Global.Cancel' | translate }}</button>
      <button mat-flat-button color="primary" [disabled]="buttonLock || loading" (click)="onSubmit()">
        {{ (data.mode === 'create' ? 'Global.Create' : 'Global.Save') | translate }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
